/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_No_Billing_PeriodInputs */



/**
* | output |
* | --- |
* | "No billing period yet" |
*
* @param {Partner_Customer_No_Billing_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_no_billing_period = /** @type {((inputs?: Partner_Customer_No_Billing_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_No_Billing_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch kein Abrechnungszeitraum")
	return /** @type {LocalizedString} */ ("No billing period yet")
});